import { ChangeDetectionStrategy, Component } from '@angular/core';

@Component({
  selector: 'app-footer',
  imports: [],

  template: ` <footer class="flex justify-end">
    <span class="text-sm font-normal text-neutral-950">
      Stuck on the form?
      <a
        class="underline font-bold"
        href="mailto:support@CourthouseComputerSystems.com?subject=Support%20request%20from%20the%20Probate%20app"
        >Contact Support</a
      >
    </span>
  </footer>`,
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class FooterComponent {}
